import { useEffect, useState, useSyncExternalStore } from 'react'
import { isOnline, subscribeOnline } from './online'
import type { OfflineQueue } from './queue'
import { queue as defaultQueue } from './singleton'

/** Есть ли сеть (с учётом принудительного офлайна dev-панели). */
export function useOnline(): boolean {
  return useSyncExternalStore(subscribeOnline, isOnline, () => true)
}

/** Размер очереди и состояние сети — для плашки «Нет связи… в очереди: N». */
export function useOfflineQueue(q: OfflineQueue = defaultQueue): { size: number; online: boolean } {
  const online = useOnline()
  const [size, setSize] = useState(q.currentSize)
  useEffect(() => {
    let alive = true
    const off = q.subscribe((n) => setSize(n))
    q.size()
      .then((n) => {
        if (alive) setSize(n)
      })
      .catch(() => {})
    return () => {
      alive = false
      off()
    }
  }, [q])
  return { size, online }
}
